const CheckboxFilterPartial = {
  parts: [
    'container',
    'searchContainer',
    'searchInputGroup',
    'searchIconWrapper',
    'searchIcon',
    'searchInput',
    'searchDivider',
    'optionsList',
    'optionItem',
    'checkbox'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      flex: '1 0 0',
      position: 'relative',
      w: 'full',
    },

    searchContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      position: 'relative',
    },

    searchInputGroup: {
      display: 'flex',
      h: '66px',
      px: 4, // 16px
      alignItems: 'center',
      gap: 4, // 16px
      alignSelf: 'stretch',
      position: 'relative',
    },

    searchIconWrapper: {
      pointerEvents: 'none',
      h: 'full',
      display: 'flex',
      alignItems: 'center',
    },

    searchIcon: {
      w: 5, // 20px
      h: 5, // 20px
      color: 'brandColors.primaryDarkLinen', // #8C683B
    },

    searchInput: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale80', // rgba(27, 26, 24, 0.80)
      fontFamily: 'heading',
      fontSize: 'sm', // 14px
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
      border: 'none',
      h: 'auto',
      _focus: {
        border: 'none',
        boxShadow: 'none',
      },
      _placeholder: {
        color: 'brandColors.greyscale80',
      },
    },

    searchDivider: {
      w: 'full',
      h: '1px',
      bg: 'brandColors.greyscale10', // WIP-Greyscale-10---keyline
      position: 'relative',
    },

    optionsList: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
    },

    optionItem: {
      display: 'flex',
      h: '66px',
      px: 4, // 16px
      alignItems: 'center',
      gap: 4, // 16px
      alignSelf: 'stretch',
      position: 'relative',
      bg: 'transparent',
      border: 'none',
      cursor: 'pointer',
      textAlign: 'left',
    },

    checkbox: {
      alignSelf: 'stretch',
      fontFamily: 'heading',
      fontSize: 'sm', // 14px
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%',
      flex: '1 0 0',
      display: 'flex',
      alignItems: 'center',
      sx: {
        '& .chakra-checkbox__control': {
          w: 6,
          h: 6,
          borderRadius: '6px',
          border: '1.5px solid',
          borderColor: 'brandColors.linen03',
          bg: 'white',
          mt: 0,
        },
        '& .chakra-checkbox__label': {
          marginLeft: 4, // 16px
        },
        '& .chakra-checkbox__control[data-checked]': {
          bg: 'brandColors.greyscale90',
          borderColor: 'brandColors.greyscale90',
        },
      },
    },
  },
};

export default CheckboxFilterPartial;
